import React, { useState } from "react";
import Layout from "../components/Layout";
import StuTable from "../components/StuTable";
import useRequest from "../../../../utils/useRequest";
import { getExamStudentDownloadRecordList } from "../../../../service/exam";
import InvigilationProvider from "../context";
import AsideDownload from "./components/AsideDownload";
import { ColumnProps } from "antd/lib/table/interface";

export default function Download() {
    const [examId, setExamId] = useState("");
    const [studentName, setStudentName] = useState("");

    const [data, { loading }, refresh] = useRequest(
        () => getExamStudentDownloadRecordList({ studentName, examId }),
        {},
        [examId, studentName]
    );
    const columns: ColumnProps<any>[] = [
        {
            title: "下载附件次数",
            dataIndex: "downloadFileTimes"
        }
    ];
    return (
        <InvigilationProvider
            examList={data?.conditionQueryList || []}
            dataSource={data?.dataList || []}
            examId={examId}
            setExamId={setExamId}>
            <Layout
                title="下载附件记录"
                refresh={refresh}
                table={
                    <StuTable
                        extraColumns={columns}
                        onErrChange={refresh}
                        dataSource={data?.dataList || []}
                        loading={loading}
                    />
                }
                aside={<AsideDownload />}
                onSearch={setStudentName}
            />
        </InvigilationProvider>
    );
}
